import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { label: '首页', path: '/' },
  { label: '网红塌房', path: '/category/wanghong-tafang' },
  { label: '黑料大瓜', path: '/category/heiliao-dagua' },
  { label: '每日爆料', path: '/category/meiri-baoliao' },
  { label: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <span className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
              吃瓜爆料网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`relative whitespace-nowrap text-sm font-medium transition-colors duration-200 cursor-pointer ${
                  location.pathname === item.path
                    ? 'text-primary-500'
                    : 'text-foreground-700 hover:text-foreground-950'
                }`}
              >
                {item.label}
                {location.pathname === item.path && (
                  <span className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-primary-500" />
                )}
              </Link>
            ))}
            <Link
              to="/about"
              className="whitespace-nowrap px-5 py-2 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
            >
              下载APP
            </Link>
          </div>

          <button
            className="md:hidden w-8 h-8 flex items-center justify-center cursor-pointer"
            onClick={() => setIsMobileOpen(!isMobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl text-foreground-950 ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`} />
          </button>
        </div>
      </div>

      {isMobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`whitespace-nowrap text-sm font-medium py-2 transition-colors cursor-pointer ${
                  location.pathname === item.path
                    ? 'text-primary-500'
                    : 'text-foreground-700 hover:text-foreground-950'
                }`}
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/about"
              className="whitespace-nowrap px-5 py-2 bg-primary-500 text-background-50 rounded-full text-sm font-semibold text-center hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
            >
              下载APP
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}